import { t } from 'utils/i18n';

export enum EFEEDBACK_STATUS {
  NONE = 'none',
  DRAFT = 'draft',
  PUBLISH = 'publish',
}

export enum EFEEDBACK_RESOURCE_PROGRESS_STATUS {
  Using = 'using', // 進行中
  NotUsing = 'notUsing', // 未使用
  Finished = 'finished', // 已結束
}

/**
 * @description 優點
 * @property QUICK_RESPONSE 反應力快
 * @property CHEERFUL 開朗活潑
 * @property ENTERPRISING 富進取心
 * @property PROACTIVE 積極回答
 * @property ARTICULATE 口條清晰
 * @property STRONG_COMPREHENSION 理解力強
 * @property GOOD_LEARNING_ABILITY 學習力佳
 * @property DILIGENT_AND_HARDWORKING 認真上進
 * @property OBSERVANT 觀察入微
 * @property GOOD_COMMUNICATION_SKILLS 良好溝通
 * @property CLEAR_THINKING 思路清晰
 * @property INITIATIVE_IN_ASKING_QUESTIONS 主動提問
 * @property RICH_CREATIVITY 創造力豐富
 * @property FLUENT_PRONUNCIATION 流利的發音
 * @property SUFFICIENT_VOCABULARY 單字量夠
 * @property GOOD_COMMAND_OF_GRAMMAR 善用句型
 * @property RICH_VOCABULARY 詞語量多
 * @property GOOD_AT_THINKING 善於思辨
 * @property ACCURATE_CALCULATION  計算準確
 * @property STRONG_REASONING 推理力強
 * @property STRONG_ANALYSIS 分析力強
 * @property CLEAR_LOGICAL_THINKING 運算邏輯清楚
 * @property METICULOUS_THINKING 思考縝密
 */
enum EADVANTAGE {
  QUICK_RESPONSE = '0',
  CHEERFUL = '1',
  ENTERPRISING = '2',
  PROACTIVE = '3',
  ARTICULATE = '4',
  STRONG_COMPREHENSION = '5',
  GOOD_LEARNING_ABILITY = '6',
  DILIGENT_AND_HARDWORKING = '7',
  OBSERVANT = '8',
  GOOD_COMMUNICATION_SKILLS = '9',
  CLEAR_THINKING = '10',
  INITIATIVE_IN_ASKING_QUESTIONS = '11',
  RICH_CREATIVITY = '12',
  FLUENT_PRONUNCIATION = '13',
  SUFFICIENT_VOCABULARY = '14',
  GOOD_COMMAND_OF_GRAMMAR = '15',
  RICH_VOCABULARY = '16',
  GOOD_AT_CRITICAL_THINKING = '17',
  ACCURATE_CALCULATION = '18',
  STRONG_REASONING = '19',
  STRONG_ANALYSIS = '20',
  CLEAR_LOGICAL_THINKING = '21',
  METICULOUS_THINKING = '22',
}

/**
 * @description 待加強
 * @property SHY 害羞
 * @property IMPATIENT 沒耐心
 * @property POOR_ORGANIZATION 統整能力較弱
 * @property LOW_INITIATIVE 積極度待加強
 * @property INATTENTIVE 細心度不夠
 * @property FEARFUL_OF_PUBLIC_SPEAKING 害怕發表
 * @property SLOW_THINKING 思考較慢
 * @property WEAK_MEMORY 記憶力較弱
 * @property SLOW_REACTION 反應較慢
 * @property NEED_TO_IMPROVE_VOCABULARY 需增加單字量
 * @property IMPROVE_PRONUNCIATION_ACCURACY 加強發音準確度
 * @property NEED_TO_PRACTICE_READING 需多練習閱讀
 * @property WEAK_SENTENCE_CONSTRUCTION 構句不夠強
 * @property INADEQUATE_COMPREHENSION 語意理解不適切
 * @property UNFAMILIARITY_WITH_FORMULAS 公式不熟悉
 * @property SLOW_CALCULATION 計算比較慢
 * @property WEAKNESS_IN_PROBLEM_SOLVING_SKILLS 應用題型判斷較弱
 * @property NEED_TO_STRENGTHEN_FUNDAMENTAL_CONCEPTS 需加強基本概念
 * @property POOR_VISUALIZATION_ABILITY 圖形理解力較弱
 */
enum EIMPROVEMENT {
  SHY = '0',
  IMPATIENT = '1',
  POOR_ORGANIZATION = '2',
  LOW_INITIATIVE = '3',
  INATTENTIVE = '4',
  FEARFUL_OF_PUBLIC_SPEAKING = '5',
  SLOW_THINKING = '6',
  WEAK_MEMORY = '7',
  SLOW_REACTION = '8',
  NEED_TO_IMPROVE_VOCABULARY = '9',
  IMPROVE_PRONUNCIATION_ACCURACY = '10',
  NEED_TO_PRACTICE_READING = '11',
  WEAK_SENTENCE_CONSTRUCTION = '12',
  INADEQUATE_COMPREHENSION = '13',
  UNFAMILIARITY_WITH_FORMULAS = '14',
  SLOW_CALCULATION = '15',
  WEAKNESS_IN_PROBLEM_SOLVING_SKILLS = '16',
  NEED_TO_STRENGTHEN_FUNDAMENTAL_CONCEPTS = '17',
  POOR_VISUALIZATION_ABILITY = '18',
}

/**
 * @description 機會
 * @property MORE_DISCUSSION_SPACE 提供更多討論空間能提升學習效果
 * @property QUANTIFY_MISTAKES 協助學生量化錯題可釐清迷思概念
 * @property BUILD_CORRECT_CONCEPTS 建立正確觀念協助孩子邏輯思考
 * @property DIGITAL_INTERACTION 透過數位化的互動方式可提升學習動機
 * @property CROSS_DOMAIN_KNOWLEDGE 補充跨領域知識面向增加深度與廣度
 * @property INSPIRE_LEARNING_FUN 透過線上課程安排啟發學習樂趣
 * @property BASIC_EXERCISES 增加基礎練習建立學習信心
 * @property ADVANCED_EXERCISES 增加進階練習挑戰自我極限
 * @property EARLY_LEARNING 孩子可超前學習，發揮天賦
 */
enum ECHANCE {
  MORE_DISCUSSION_SPACE = '0',
  QUANTIFY_MISTAKES = '1',
  BUILD_CORRECT_CONCEPTS = '2',
  DIGITAL_INTERACTION = '3',
  CROSS_DOMAIN_KNOWLEDGE = '4',
  INSPIRE_LEARNING_FUN = '5',
  BASIC_EXERCISES = '6',
  ADVANCED_EXERCISES = '7',
  EARLY_LEARNING = '8',
}

export const EADVANTAGE_TEXT = {
  [EADVANTAGE.QUICK_RESPONSE]: t(
    'constants.course.feedback.eAdvantage.QUICK_RESPONSE',
    '反應力快',
  ),
  [EADVANTAGE.CHEERFUL]: t(
    'constants.course.feedback.eAdvantage.CHEERFUL',
    '開朗活潑',
  ),
  [EADVANTAGE.ENTERPRISING]: t(
    'constants.course.feedback.eAdvantage.ENTERPRISING',
    '富進取心',
  ),
  [EADVANTAGE.PROACTIVE]: t(
    'constants.course.feedback.eAdvantage.PROACTIVE',
    '積極回答',
  ),
  [EADVANTAGE.ARTICULATE]: t(
    'constants.course.feedback.eAdvantage.ARTICULATE',
    '口條清晰',
  ),
  [EADVANTAGE.STRONG_COMPREHENSION]: t(
    'constants.course.feedback.eAdvantage.STRONG_COMPREHENSION',
    '理解力強',
  ),
  [EADVANTAGE.GOOD_LEARNING_ABILITY]: t(
    'constants.course.feedback.eAdvantage.GOOD_LEARNING_ABILITY',
    '學習力佳',
  ),
  [EADVANTAGE.DILIGENT_AND_HARDWORKING]: t(
    'constants.course.feedback.eAdvantage.DILIGENT_AND_HARDWORKING',
    '認真上進',
  ),
  [EADVANTAGE.OBSERVANT]: t(
    'constants.course.feedback.eAdvantage.OBSERVANT',
    '觀察入微',
  ),
  [EADVANTAGE.GOOD_COMMUNICATION_SKILLS]: t(
    'constants.course.feedback.eAdvantage.GOOD_COMMUNICATION_SKILLS',
    '良好溝通',
  ),
  [EADVANTAGE.CLEAR_THINKING]: t(
    'constants.course.feedback.eAdvantage.CLEAR_THINKING',
    '思路清晰',
  ),
  [EADVANTAGE.INITIATIVE_IN_ASKING_QUESTIONS]: t(
    'constants.course.feedback.eAdvantage.INITIATIVE_IN_ASKING_QUESTIONS',
    '主動提問',
  ),
  [EADVANTAGE.RICH_CREATIVITY]: t(
    'constants.course.feedback.eAdvantage.RICH_CREATIVITY',
    '創造力豐富',
  ),
  [EADVANTAGE.FLUENT_PRONUNCIATION]: t(
    'constants.course.feedback.eAdvantage.FLUENT_PRONUNCIATION',
    '流利的發音',
  ),
  [EADVANTAGE.SUFFICIENT_VOCABULARY]: t(
    'constants.course.feedback.eAdvantage.SUFFICIENT_VOCABULARY',
    '單字量夠',
  ),
  [EADVANTAGE.GOOD_COMMAND_OF_GRAMMAR]: t(
    'constants.course.feedback.eAdvantage.GOOD_COMMAND_OF_GRAMMAR',
    '善用句型',
  ),
  [EADVANTAGE.RICH_VOCABULARY]: t(
    'constants.course.feedback.eAdvantage.RICH_VOCABULARY',
    '詞語量多',
  ),
  [EADVANTAGE.GOOD_AT_CRITICAL_THINKING]: t(
    'constants.course.feedback.eAdvantage.GOOD_AT_CRITICAL_THINKING',
    '善於思辨',
  ),
  [EADVANTAGE.ACCURATE_CALCULATION]: t(
    'constants.course.feedback.eAdvantage.ACCURATE_CALCULATION',
    '計算準確',
  ),
  [EADVANTAGE.STRONG_REASONING]: t(
    'constants.course.feedback.eAdvantage.STRONG_REASONING',
    '推理力強',
  ),
  [EADVANTAGE.STRONG_ANALYSIS]: t(
    'constants.course.feedback.eAdvantage.STRONG_ANALYSIS',
    '分析力強',
  ),
  [EADVANTAGE.CLEAR_LOGICAL_THINKING]: t(
    'constants.course.feedback.eAdvantage.CLEAR_LOGICAL_THINKING',
    '運算邏輯清楚',
  ),
  [EADVANTAGE.METICULOUS_THINKING]: t(
    'constants.course.feedback.eAdvantage.METICULOUS_THINKING',
    '思考縝密',
  ),
} as const;

export const EIMPROVEMENT_TEXT = {
  [EIMPROVEMENT.SHY]: t('constants.course.feedback.eImprovement.SHY', '較害羞'),
  [EIMPROVEMENT.IMPATIENT]: t(
    'constants.course.feedback.eImprovement.IMPATIENT',
    '沒耐心',
  ),
  [EIMPROVEMENT.POOR_ORGANIZATION]: t(
    'constants.course.feedback.eImprovement.POOR_ORGANIZATION',
    '統整能力較弱',
  ),
  [EIMPROVEMENT.LOW_INITIATIVE]: t(
    'constants.course.feedback.eImprovement.LOW_INITIATIVE',
    '積極度待加強',
  ),
  [EIMPROVEMENT.INATTENTIVE]: t(
    'constants.course.feedback.eImprovement.INATTENTIVE',
    '細心度不夠',
  ),
  [EIMPROVEMENT.FEARFUL_OF_PUBLIC_SPEAKING]: t(
    'constants.course.feedback.eImprovement.FEARFUL_OF_PUBLIC_SPEAKING',
    '害怕發表',
  ),
  [EIMPROVEMENT.SLOW_THINKING]: t(
    'constants.course.feedback.eImprovement.SLOW_THINKING',
    '思考較慢',
  ),
  [EIMPROVEMENT.WEAK_MEMORY]: t(
    'constants.course.feedback.eImprovement.WEAK_MEMORY',
    '記憶力較弱',
  ),
  [EIMPROVEMENT.SLOW_REACTION]: t(
    'constants.course.feedback.eImprovement.SLOW_REACTION',
    '反應較慢',
  ),
  [EIMPROVEMENT.NEED_TO_IMPROVE_VOCABULARY]: t(
    'constants.course.feedback.eImprovement.NEED_TO_IMPROVE_VOCABULARY',
    '需增加單字量',
  ),
  [EIMPROVEMENT.IMPROVE_PRONUNCIATION_ACCURACY]: t(
    'constants.course.feedback.eImprovement.IMPROVE_PRONUNCIATION_ACCURACY',
    '加強發音準確度',
  ),
  [EIMPROVEMENT.NEED_TO_PRACTICE_READING]: t(
    'constants.course.feedback.eImprovement.NEED_TO_PRACTICE_READING',
    '需多練習閱讀',
  ),
  [EIMPROVEMENT.WEAK_SENTENCE_CONSTRUCTION]: t(
    'constants.course.feedback.eImprovement.WEAK_SENTENCE_CONSTRUCTION',
    '構句不夠強',
  ),
  [EIMPROVEMENT.INADEQUATE_COMPREHENSION]: t(
    'constants.course.feedback.eImprovement.INADEQUATE_COMPREHENSION',
    '語意理解不適切',
  ),
  [EIMPROVEMENT.UNFAMILIARITY_WITH_FORMULAS]: t(
    'constants.course.feedback.eImprovement.UNFAMILIARITY_WITH_FORMULAS',
    '公式不熟悉',
  ),
  [EIMPROVEMENT.SLOW_CALCULATION]: t(
    'constants.course.feedback.eImprovement.SLOW_CALCULATION',
    '計算比較慢',
  ),
  [EIMPROVEMENT.WEAKNESS_IN_PROBLEM_SOLVING_SKILLS]: t(
    'constants.course.feedback.eImprovement.WEAKNESS_IN_PROBLEM_SOLVING_SKILLS',
    '應用題型判斷較弱',
  ),
  [EIMPROVEMENT.NEED_TO_STRENGTHEN_FUNDAMENTAL_CONCEPTS]: t(
    'constants.course.feedback.eImprovement.NEED_TO_STRENGTHEN_FUNDAMENTAL_CONCEPTS',
    '需加強基本概念',
  ),
  [EIMPROVEMENT.POOR_VISUALIZATION_ABILITY]: t(
    'constants.course.feedback.eImprovement.POOR_VISUALIZATION_ABILITY',
    '圖形理解力較弱',
  ),
} as const;

export const ECHANCE_TEXT = {
  [ECHANCE.MORE_DISCUSSION_SPACE]: t(
    'constants.course.feedback.eChance.MORE_DISCUSSION_SPACE',
    '提供更多討論空間能提升學習效果',
  ),
  [ECHANCE.QUANTIFY_MISTAKES]: t(
    'constants.course.feedback.eChance.QUANTIFY_MISTAKES',
    '協助學生量化錯題可釐清迷思概念',
  ),
  [ECHANCE.BUILD_CORRECT_CONCEPTS]: t(
    'constants.course.feedback.eChance.BUILD_CORRECT_CONCEPTS',
    '建立正確觀念協助孩子邏輯思考',
  ),
  [ECHANCE.DIGITAL_INTERACTION]: t(
    'constants.course.feedback.eChance.DIGITAL_INTERACTION',
    '透過數位化的互動方式可提升學習動機',
  ),
  [ECHANCE.CROSS_DOMAIN_KNOWLEDGE]: t(
    'constants.course.feedback.eChance.CROSS_DOMAIN_KNOWLEDGE',
    '補充跨領域知識面向增加深度與廣度',
  ),
  [ECHANCE.INSPIRE_LEARNING_FUN]: t(
    'constants.course.feedback.eChance.INSPIRE_LEARNING_FUN',
    '透過線上課程安排啟發學習樂趣',
  ),
  [ECHANCE.BASIC_EXERCISES]: t(
    'constants.course.feedback.eChance.BASIC_EXERCISES',
    '增加基礎練習建立學習信心',
  ),
  [ECHANCE.ADVANCED_EXERCISES]: t(
    'constants.course.feedback.eChance.ADVANCED_EXERCISES',
    '增加進階練習挑戰自我極限',
  ),
  [ECHANCE.EARLY_LEARNING]: t(
    'constants.course.feedback.eChance.EARLY_LEARNING',
    '孩子可超前學習，發揮天賦',
  ),
} as const;
